import { H2, Space } from '@dnb/eufemia';
import { JSX } from 'react';

import RequestTimeline, {
  RequestProps,
} from '@/pages/profile/apps/application/components/EntitlementRequest/components/RequestTimeline';
import ScopeCard from '@/pages/profile/apps/application/components/ScopeCard';

type ScopeProps = {
  name: string;
  description: string;
  id: string;
  envs: string[];
};

export function EntitlementRequestDetails({
  apiName,
  groupedRequest,
  requestProps,
}: {
  apiName: string;
  groupedRequest: ScopeProps[];
  requestProps: RequestProps;
}): JSX.Element {
  return (
    <>
      <H2>{apiName}</H2>
      <RequestTimeline request={requestProps} />
      {requestProps.scopes.length === 0 && requestProps.testScopes.length === 0 && (
        <ScopeCard
          environments={['Test', 'Live']}
          reviewStatus={requestProps.decision}
          scopeDescription="Request for full access"
          scopeId="all"
          scopeName="Full access"
          showAccessSection
        />
      )}
      {groupedRequest.map((scope) => (
        <Space bottom="small" key={scope.name}>
          <ScopeCard
            environments={scope.envs}
            reviewStatus={requestProps.decision}
            scopeDescription={scope.description}
            scopeId={scope.id}
            scopeName={scope.name}
            showAccessSection
          />
        </Space>
      ))}
    </>
  );
}
